import React from 'react';
import { useDMEContextSelector, useDMEDispatch } from './DashboardMaintenanceEnquiry.context';
import { RouteComponentProps } from 'react-router';

export const useTabLocations = (url: string, location: RouteComponentProps['location'], selectedTemplateId: number) => {

    const contextDispatch = useDMEDispatch();
    const selectedContextTemplateId = useDMEContextSelector<'DashboardId'>((state) => state.DashboardId);
    const DashboardId = selectedTemplateId || selectedContextTemplateId;

    const tabLocations = React.useMemo(
        () => {
            return {
                DashboardDetails: {
                    pathname: `${url.endsWith('/') ? url : `${url}/`}dashboard-details`,
                    search: `?DashboardId=${DashboardId}`
                },
                DashboardLayout: {
                    pathname: `${url.endsWith('/') ? url : `${url}/`}dashboard-layout`,
                    search: `?DashboardId=${DashboardId}`
                },
                QuickLinks: {
                    pathname: `${url.endsWith('/') ? url : `${url}/`}quick-links`,
                    search: `?DashboardId=${DashboardId}`
                },
            };
        },
        [url, DashboardId]
    );

    React.useEffect(
        () => {
            const params = (new URLSearchParams(location.search));
            const dashboardIdParam = params.get('DashboardId') || '';

            contextDispatch({
                setDashboardId: Number(dashboardIdParam),
            });
        },
        [contextDispatch, location]
    );

    return {
        tabLocations
    };
};
